import { gql } from "@apollo/client";

export const COMPANY_USERS_QUERY = gql`
  query CompanyUsers {
    companyUsers {
      id
      email
      firstName
      lastName
      role
      companyId
      schema
      twoFactorEnabled
      invitationStatus
      invitedBy
      invitedOn
    }
  }
`;

// Users Query (for Team management)

// Locations Query
// export const LOCATIONS_QUERY = gql`query Locations {
//     locations {
//         id
//         locationName
//         description
//         name
//         type
//         address1
//         address2
//         city
//         state
//         zip
//         countryAlpha2
//         coordinates
//         parentId
//         createdAt
//         updatedAt
//         deletedAt
//         fileIds
//         sublocation
//         address
//         locationType
//     }
// }
// `;
